// extracted by mini-css-extract-plugin
export default {"CVButton":"CVDownload_CVButton__JJBQ4","CVButtonDiv":"CVDownload_CVButtonDiv__zJRdQ"};